import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, input, InputSignal, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { getRegionUrl, Region } from '../../util/region.util';

/**
 * Full screen notice shown when a user opens the application of a region they hold
 * no role in. Offers a link to the regional application their roles belong to.
 */
@Component({
    selector: 'app-wrong-region',
    templateUrl: './wrong-region.component.html',
    imports: [TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WrongRegionComponent {
    /** Region the user holds roles in, i.e. the one they are pointed to. */
    public readonly region: InputSignal<Region> = input.required<Region>();

    protected readonly regionLabel: Signal<string> = computed(() => this.region().toUpperCase());
    protected readonly regionUrl: Signal<string> = computed(() => getRegionUrl(this.region()));
}
